import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { AbstractView } from 'src/app/core/abstract_view';

@Component({
  selector: 'app-promotional-menu',
  templateUrl: './promotional-menu.component.html'
})
export class PromotionalMenuComponent extends AbstractView implements OnInit {
  public model: any[] = [];

  constructor(public messageService: MessageService, public router: Router) {
    super(messageService, router);
  }

  ngOnInit(): void {
    this.model.push({
      label: 'Venta Masiva MisPedidos',
      icon: '',
      routerLink: ['/promotional/massive-sales'],
    });
  }

}
